/**
 * Official Module Routes (extracted from index.tsx)
 */
import React from 'react';
import { Result } from 'antd';
import { RouteItem } from './index';
import { HomeOutlined, FormOutlined, OrderedListOutlined, PlusOutlined, FileProtectOutlined, FileTextOutlined, TranslationOutlined, KeyOutlined, IdcardOutlined } from '@ant-design/icons';

// Shared forms
import FormDefinitionsList from "../components/common/Forms/FormDefinitionsList";
import FormDefinitionEditor from "../components/common/Forms/FormDefinitionEditor";
import FormRecordDetailsList from '../components/common/Forms/FormRecordDetailsList';
import PdfToReactFormGenerator from "../components/common/Forms/PdfToReactFormGenerator";

const UnderConstruction = ({ title }: { title: string }) => (
  <Result status="info" title={`${title} Module`} subTitle="Under Construction." />
);

export const officialRoutes: Record<string, RouteItem> = {
  // OFFICIAL modülü
  official: {path: '/official', element: null, label: 'Official', showInMenu: false,
    children: {
      dashboard: {path: '/official/dashboard', element: <UnderConstruction title="Official" />, label: 'Dashboard', icon: <HomeOutlined />, showInMenu: true},
      forms: {path: '/official/forms', element: <UnderConstruction title="Forms" />, label: 'Forms', icon: <FormOutlined />, showInMenu: true,
        grandchildren: {
          group: {path: '/official/forms/gr_create', element: <UnderConstruction title="New Form Group" />, label: 'New Form Group', icon: <PlusOutlined />, showInMenu: true},
          definitions: {path: '/official/forms/definitions', element: <FormDefinitionsList />, label: 'Form Definitions', icon: <OrderedListOutlined />, showInMenu: true},
          definitions_create: {path: '/official/forms/definitions/create', element: <PdfToReactFormGenerator/>, label: 'Create Form Definition', showInMenu: false},
          definitions_edit: {path: '/official/forms/definitions/edit/:id', element: <FormDefinitionEditor />, label: 'Edit Form Definition', showInMenu: false},
          list_record_details: {path: '/official/forms/list_record_details', element: <FormRecordDetailsList />, label: 'Form Record Details', icon: <OrderedListOutlined />, showInMenu: true},
          create: {path: '/official/forms/create', element: <PdfToReactFormGenerator/>, label: 'Create Form', icon: <PlusOutlined />, showInMenu: true},
          fill: {path: '/official/forms/fill', element: <UnderConstruction title="Fill Form"/>, label: 'Fill Form',  showInMenu: true},
          edit: {path: '/official/forms/edit/:id', element: <UnderConstruction title="Edit Form"/>, label: 'Edit Form', showInMenu: false},
        },
      },
      acts: {path: '/official/acts', element: <UnderConstruction title="Acts" />, label: 'Acts', icon: <FileProtectOutlined />, showInMenu: false},
      logs: {path: '/official/logs', element: <UnderConstruction title="Logs" />, label: 'Logs', icon: <FileTextOutlined />, showInMenu: false},
      permissions: {path: '/official/permissions', element: <UnderConstruction title="Permissions" />, label: 'Permissions', icon: <KeyOutlined />, showInMenu: false},
      licenses: {path: '/official/licenses', element: <UnderConstruction title="Licenses" />, label: 'Licenses', icon: <IdcardOutlined />, showInMenu: false},
      applications: {path: '/official/applications', element: <UnderConstruction title="Applications" />, label: 'Applications', icon: <FormOutlined />, showInMenu: false},
    },
  },
};
